const logoPopup = document.getElementById('license-popup');
const logoPopupCloseButton = document.getElementById('license-popup__close-button');
const logoPopupInner = document.getElementById('license-popup__inner');
const logoPopupTrigger = document.getElementById('license-popup-trigger');

if (logoPopup) {
  logoPopup.addEventListener('close', function () {
    document.body.classList.remove('prevent-scroll');
  });
}

if (logoPopupTrigger) {
  logoPopupTrigger.addEventListener('click', function () {
    logoPopup.showModal();

    document.body.classList.add('prevent-scroll');
  });

  document.addEventListener('click', function (event) {
    if (logoPopup.open && !logoPopupInner.contains(event.target) && !event.target.closest('#license-popup-trigger') && !event.target.closest('#upload-button')) {
      logoPopup.close();
    }
  });
}

if (logoPopupCloseButton) {
  logoPopupCloseButton.addEventListener('click', function () {
    logoPopup.close();
  });
}
